import styled from 'styled-components';
import { borderRadius, position } from 'polished';

import { Theme } from './theme';

export const AutoComplete = styled.div`
  .${props => props.classPrefix} {
    &__container {
      position: relative;
      width: 100%;
    }

    &__input {
      font-size: 16px;
      border-radius: 4px;
      padding: 11px 15px;
      outline: none;
      border: 1px solid #eee;
      position: relative;
      background-color: ${Theme.snow};
      background-image: none;
      vertical-align: middle;
      width: 100%;
      margin-bottom: 10px;
    }

    &__suggestions-container {
      margin-top: 5px;
      color: ${Theme.back};
      ${position('absolute', '43px', 0, 'auto', 0)};
      width: 100%;
      border: 0;
      background-color: ${Theme.snow};
      ${borderRadius('bottom', '5px')} box-shadow: inset 0 1px 1px rgba(0,0,0,.075),
        0 0 8px hsla(0,0%,53%,.6);
      z-index: 3;
    }

    &__container--open &__suggestions-container {
      display: block;
    }

    &__suggestions-list {
      margin: 0;
      padding: 0;
      list-style-type: none;

      li {
        font-size: 16px;
      }
    }

    &__suggestion {
      cursor: pointer;
      padding: 5px 10px;
      margin: 2px;
    }

    &__suggestion--focused {
      background-color: ${Theme.primary};
      border-radius: 2px;
      color: ${Theme.snow};
    }
  }
`;
